import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
function Root() {
  useEffect(() => {
    if ((window as any).fbq) return;
    // Meta Pixel - safe injection
    const w = window as any;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    w.fbq = n;
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.documentElement).appendChild(script);
    n('init', '1497007874735639');
    n('track', 'PageView');
  }, []);
  return <App data-id="element-333" />;
}
render(<Root data-id="element-334" />, document.getElementById('root'));